/**
 * Default issue slug used when the route is hit without an explicit `:slug`
 * (e.g. `/digest` → latest issue). Mirrors the S3 object key layout
 * `magazine/{slug}/filescan-digest-{slug}.pdf`.
 */
export const DEFAULT_REWARD_SLUG = '2026-summer'

/**
 * Consent copy version recorded alongside the marketing-consent flag.
 * Bump whenever the consent wording below changes so stored leads stay auditable.
 */
export const CONSENT_TEXT_VERSION = '2026-07'

/**
 * Vertical / industry options for the lead-capture gate. `labelKey` is a
 * translation key, not the visible text — callers run it through `_t`.
 */
export const REWARD_VERTICALS: { value: string; labelKey: string }[] = [
  { value: 'critical-infrastructure', labelKey: 'vertical-critical-infrastructure' },
  { value: 'financial-services', labelKey: 'vertical-financial-services' },
  { value: 'government', labelKey: 'vertical-government' },
  { value: 'healthcare', labelKey: 'vertical-healthcare' },
  { value: 'manufacturing', labelKey: 'vertical-manufacturing' },
  { value: 'technology', labelKey: 'vertical-technology' },
  { value: 'energy-utilities', labelKey: 'vertical-energy-utilities' },
  { value: 'education', labelKey: 'vertical-education' },
  { value: 'other', labelKey: 'other' },
]
